import { useMutation } from '@tanstack/react-query';
import { uploadAttachment, uploadDirectlyToS3 } from '../../../../services/general';

const IMAGE_TYPE_PREFIX = 'image/';
export const isImageFile = (file) => file.type.startsWith(IMAGE_TYPE_PREFIX);

export function useUploadClientLogo({ onSuccess, onError } = {}) {
  return useMutation({
    mutationFn: async ({ file, folderName }) => {
      if (!isImageFile(file)) {
        throw new Error('Only image files can be uploaded.');
      }
      if (!folderName?.trim()) {
        throw new Error('A folder name is required before uploading.');
      }

      // Step 1 — sign
      const { documentId, uploadUrl, uploadFields } = await uploadAttachment({
        fileName: file.name,
        fileSize: file.size,
        contentType: file.type,
        folderName,
        rootFolder: 'logos', // fixed per spec — logos always live under this root
      });

      // Step 2 — upload straight to S3. "file" must be the LAST field.
      const formData = new FormData();
      Object.entries(uploadFields).forEach(([key, value]) => formData.append(key, value));
      formData.append('file', file);

      await uploadDirectlyToS3(uploadUrl, formData);

      // S3 returns 204 No Content — carry forward what we already know.
      return {
        documentId,
        name: file.name,
        fileSize: file.size,
        contentType: file.type,
      };
    },
    onSuccess,
    onError,
  });
}
